// app.routes.ts
import { Routes } from '@angular/router';
import { DefaultLayoutComponent } from './layout';
import { MsalGuard } from '@azure/msal-angular';
import { RoleGuard } from './role.guard';
import { AuthCallbackComponent } from './auth-callback.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
   { 
     path: 'auth-callback',
     component: AuthCallbackComponent 
   },
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      {
        path: 'profile',
        loadChildren: () => import('./views/profile/routes').then(m => m.routes),
        canActivate: [MsalGuard, RoleGuard],
        data: { roles: ['ROSAIAgent', 'ROSAdmin'] }
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/routes').then(m => m.routes),
        canActivate: [MsalGuard]
      },
      {
        path: 'prompts',
        loadChildren: () => import('./views/prompts/routes').then(m => m.routes),
        canActivate: [MsalGuard, RoleGuard],
        data: { roles: ['ROSAIAgent', 'ROSAdmin'] }
      },
      {
        path: 'agent-emails',
        loadChildren: () => import('./views/setup/agent-email/routes').then(m => m.routes),
        canActivate: [MsalGuard, RoleGuard],
        data: { roles: ['ROSAdmin'] }
      },
      {
        path: 'emails',
        loadChildren: () => import('./views/setup/emails/routes').then(m => m.routes),
        canActivate: [MsalGuard, RoleGuard],
        data: { roles: ['ROSAIAgent', 'ROSAdmin'] }
      },
      {
        path: 'intents',
        loadChildren: () => import('./views/setup/intent/routes').then(m => m.routes),
        canActivate: [MsalGuard, RoleGuard],
        data: { roles: ['ROSAIAgent', 'ROSAdmin'] }
      },
      {
        path: 'clients',
        loadChildren: () => import('./views/clients/routes').then(m => m.routes),
        canActivate: [MsalGuard, RoleGuard],
        data: { roles: ['ROSAIAgent', 'ROSAdmin'] }
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
